var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.236786,
    width: 32,
    height: 32,
    rx: 4.82077,
    fill: "#0891B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76892 13.0229L15.1087 17.2495C15.6485 17.6093 16.3517 17.6093 16.8914 17.2495L23.2312 13.0229M10.3758 21.861H21.6243C22.5118 21.861 23.2312 21.1416 23.2312 20.2541V12.2195C23.2312 11.332 22.5118 10.6125 21.6243 10.6125H10.3758C9.48836 10.6125 8.76892 11.332 8.76892 12.2195V20.2541C8.76892 21.1416 9.48836 21.861 10.3758 21.861Z",
    stroke: "white",
    strokeWidth: 1.60692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon.1.7ca99d3a0c0531d28ab0b330837a5f43.svg";
export { ForwardRef as ReactComponent };